import { render, staticRenderFns } from "./AdminVendorProfile.vue?vue&type=template&id=7a93cc0a"
import script from "./AdminVendorProfile.vue?vue&type=script&lang=ts"
export * from "./AdminVendorProfile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports